var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "title" }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("settings.department.threshold.threshold")) +
          "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hr" }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("span", { staticClass: "lable" }, [
          _vm._v(
            _vm._s(_vm.$t("settings.department.threshold.thresholdValue"))
          ),
        ]),
        _vm._v(" "),
        _c("InputField", {
          directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
          attrs: {
            autoTrim: true,
            showFlag: true,
            showColon: false,
            showEmptyDash: true,
            hideLabel: true,
            required: true,
            readonlyAsInput: _vm.allowEdit,
            value: _vm.value,
            inputCheckType: "integer",
            inputTip: _vm.inputTip,
            pattern: /^\d{1,11}$/,
            dirtyCheck: true,
            extendClass: "department-threshold",
          },
          on: { updateValue: _vm.updateValue },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }